var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinManArmFore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "60px",
    viewBox: "0 0 38 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CoinManArmFore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CoinManArmFore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.2901755,59.0989695 L37.2901755,59.0989695 C36.2336933,60.2801242 34.3900282,60.3032018 33.1885387,59.1493206 L28.9936828,55.1411569 C27.7921933,53.9893737 27.6575436,52.0812738 28.7140258,50.901168 C29.7601503,49.7200132 31.614173,49.6969356 32.8156626,50.8497678 L37.0105184,54.8589805 C38.212008,56.0107638 38.3363,57.9188637 37.2901755,59.0989695",
    id: "Fill-279",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0195959,4.67752166 C18.0195959,4.67752166 7.87702783,28.4050053 12.2678359,32.6071001 C16.658644,36.8101917 33,48.742706 33,48.742706 L29.1555594,55 C29.1555594,55 1.67823992,42.9199739 0.227882494,35.9928962 C-1.59003127,27.319597 8.06577298,0 8.06577298,0 L18.0195959,4.67752166",
    id: "Fill-280",
    fill: "#4E62E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinManArmFore);
export default __webpack_public_path__ + "static/media/CoinManArmFore.c88f05fbb4a8a6bb0c41ab48f263d43a.svg";
export { ForwardRef as ReactComponent };